const nonOpaqueMaterials = [
  { material: `SGU-Clear-5mm-VLT87`, uValue: 5.71, shgcUnshaded: 0.95 },
  { material: `SGU-Clear-6mm-VLT86	`, uValue: 5.68, shgcUnshaded: 0.93 },
  { material: `SGU-Solar control glass-6mm-VLT65`, uValue: 5.4, shgcUnshaded: 0.73 },
  { material: `SGU-Clear-5mm-VLT85`, uValue: 5.8, shgcUnshaded: 0.8 },
  { material: `6mm ST 167 (Saint Gobain) Glass`, uValue: 5.6, shgcUnshaded: 0.68 },

  { material: `SGU-Uncoated-Clear-3.20mm-VLT90`, uValue: 5.91, shgcUnshaded: 0.86 },
  { material: `SGU-Uncoated-Clear-6.40mm-VLT89`, uValue: 5.91, shgcUnshaded: 0.81 },
  { material: `SGU-Uncoated-Bronze-3.20mm-VLT68`, uValue: 5.91, shgcUnshaded: 0.73 },

  { material: `SGU-Uncoated-Bronze-6.40mm-VLT55`, uValue: 5.91, shgcUnshaded: 0.62 },
  { material: `SGU-Uncoated-Green-3.20mm-VLT82`, uValue: 5.91, shgcUnshaded: 0.71 },
  { material: `SGU-Uncoated-Green-6.40mm-VLT74`, uValue: 5.91, shgcUnshaded: 0.58 },
  { material: `SGU-Uncoated-Grey-3.20mm-VLT62`, uValue: 5.91, shgcUnshaded: 0.7 },
  { material: `SGU-Uncoated-Grey-6.40mm-VLT4`, uValue: 5.91, shgcUnshaded: 0.56 },
  { material: `SGU-Uncoated-Bluegreen-3.20mm-VLT75`, uValue: 5.91, shgcUnshaded: 0.62 },
  { material: `SGU-Reflective-SS:Clear8%-6.40mm-VLT08`, uValue: 5.91, shgcUnshaded: 0.19 },
  { material: `SGU-Reflective-SS:Clear14%-6.40mm-VLT14`, uValue: 5.91, shgcUnshaded: 0.25 },
  { material: `SGU-Reflective-SS:Clear8%-6.40mm-VLT20`, uValue: 5.91, shgcUnshaded: 0.31 },
  { material: `SGU-Reflective-SS:Green14%-6.40mm-VLT12`, uValue: 5.91, shgcUnshaded: 0.25 },

  { material: `SGU-Reflective-TI:Clear20%-6.40mm-VLT20`, uValue: 5.91, shgcUnshaded: 0.29 },
  { material: `SGU-Reflective-TI:Clear30%-6.40mm-VLT30`, uValue: 5.91, shgcUnshaded: 0.39 },

  { material: `DGU-Clear-Clear-3.20mm-VLT81`, uValue: 2.73, shgcUnshaded: 0.75 },
  { material: `DGU-Clear-Clear-6.40mm-VLT78`, uValue: 2.73, shgcUnshaded: 0.7 },
  { material: `DGU-Bronze-Clear-3.20mm-VLT62`, uValue: 2.73, shgcUnshaded: 0.62 },
  { material: `DGU-Bronze-Clear-6.40mm-VLT48`, uValue: 2.73, shgcUnshaded: 0.5 },
  { material: `DGU-Green-Clear-3.20mm-VLT74`, uValue: 2.73, shgcUnshaded: 0.6 },
  { material: `DGU-Green-Clear-6.40mm-VLT66`, uValue: 2.73, shgcUnshaded: 0.47 },
  { material: `DGU-Grey-Clear-3.20mm-VLT56`, uValue: 2.73, shgcUnshaded: 0.59 },
  { material: `DGU-Grey-Clear-6.40mm-VLT40`, uValue: 2.73, shgcUnshaded: 0.44 },
  { material: `DGU-Bluegreen-Clear-6.40mm-VLT67`, uValue: 2.73, shgcUnshaded: 0.5 },
  { material: `DGU-HP-Green-Clear-6.40mm-VLT59`, uValue: 2.73, shgcUnshaded: 0.39 },
  { material: `DGU-Reflective-SS:Clear8%-Clear-6.4mm-VLT7`, uValue: 2.73, shgcUnshaded: 0.13 },
  { material: `DGU-Reflective-SS:Clear14%-Clear-6.4mm-VLT13`, uValue: 2.73, shgcUnshaded: 0.17 },
  { material: `DGU-Reflective-SS:Clear20%-Clear-6.4mm-VLT18`, uValue: 2.73, shgcUnshaded: 0.22 },
  { material: `DGU-Reflective-SS:Green14%-Clear-6.4mm-VLT11`, uValue: 2.73, shgcUnshaded: 0.16 },
  { material: `DGU-Reflective-TI:Clear20%-Clear-6.4mm-VLT18`, uValue: 2.73, shgcUnshaded: 0.21 },
  { material: `DGU-Reflective-TI:Clear30%-Clear-6.4mm-VLT27`, uValue: 2.73, shgcUnshaded: 0.29 },

  { material: `DGU-Low:e-Clear-3.2mm-VLT76`, uValue: 1.99, shgcUnshaded: 0.65 },
  { material: `DGU-Low:e-Clear-6.4mm-VLT73`, uValue: 1.99, shgcUnshaded: 0.6 },
  { material: `DGU-Clear-Low:e-3.2mm-VLT76`, uValue: 1.99, shgcUnshaded: 0.7 },
  { material: `DGU-Clear-Low:e-6.4mm-VLT73`, uValue: 1.99, shgcUnshaded: 0.65 },
  { material: `DGU-Bronze-Low:e-3.2mm-VLT58`, uValue: 1.99, shgcUnshaded: 0.57 },
  { material: `DGU-Bronze-Low:e-6.4mm-VLT45`, uValue: 1.99, shgcUnshaded: 0.45 },
  { material: `DGU-Green-Low:e-3.2mm-VLT70`, uValue: 1.99, shgcUnshaded: 0.55 },
  { material: `DGU-Green-Low:e-6.4mm-VLT61`, uValue: 1.99, shgcUnshaded: 0.42 },
  { material: `DGU-Grey-Low:e-3.2mm-VLT53`, uValue: 1.99, shgcUnshaded: 0.54 },
  { material: `DGU-Grey-Low:e-6.4mm-VLT37`, uValue: 1.99, shgcUnshaded: 0.39 },
  { material: `DGU-Bluegreen-Low:e-6.4mm-VLT62`, uValue: 1.99, shgcUnshaded: 0.45 },
  { material: `DGU-HP-Green-Low:e-6.4mm-VLT55`, uValue: 1.99, shgcUnshaded: 0.34 },

  { material: `DGU-Clear-Low:e-3.2mm-VLT75`, uValue: 1.82, shgcUnshaded: 0.54 },
  { material: `DGU-Clear-Low:e-6.4mm-VLT76`, uValue: 1.82, shgcUnshaded: 0.51 },
  { material: `DGU-HP-Green-Low:e-6.4mm-VLT57`, uValue: 1.82, shgcUnshaded: 0.31 },

  { material: `TGU-Clear-Clear-Clear-3.2mm-VLT74`, uValue: 1.76, shgcUnshaded: 0.67 },
  { material: `TGU-Clear-Clear-Clear-6.4mm-VLT70`, uValue: 1.76, shgcUnshaded: 0.61 },
  { material: `TGU-HP-Green-Clear-Clear-6.4mm-VLT53`, uValue: 1.76, shgcUnshaded: 0.34 },

  { material: `TGU-Low:e-Clear-Clear-3.2mm-VLT68`, uValue: 1.87, shgcUnshaded: 0.6 },
  { material: `TGU-Low:e-Clear-Clear-3.2mm-VLT64`, uValue: 1.87, shgcUnshaded: 0.53 },
  { material: `TGU-Clear-Clear-Low:e-3.2mm-VLT68`, uValue: 1.87, shgcUnshaded: 0.62 },
  { material: `TGU-Clear-Clear-Low:e-6.4mm-VLT68`, uValue: 1.87, shgcUnshaded: 0.56 },
  { material: `TGU-Clear-Low:e-Clear-3.2mm-VLT62`, uValue: 1.53, shgcUnshaded: 0.45 },
  { material: `TGU-Clear-Low:e-Clear-3.2mm-VLT59`, uValue: 1.53, shgcUnshaded: 0.41 },
  { material: `TGU-Low:e-Low:e-Clear-3.2mm-VLT58`, uValue: 1.53, shgcUnshaded: 0.32 },
  { material: `TGU-Low:e-Low:e-Clear-3.2mm-VLT55`, uValue: 1.53, shgcUnshaded: 0.31 },

  { material: `DGU-6(Solar control)-12(air)-6(clear glass)/VLT59	`, uValue: 2.8, shgcUnshaded: 0.6 },
  { material: `DGU-6(Solar control)-12(air)-6(clear glass)/VLT18`, uValue: 2.8, shgcUnshaded: 0.29 },
  { material: `DGU-6(Solar control)-12(air)-6(low-E glass)/VLT55	`, uValue: 1.88, shgcUnshaded: 0.59 },

  // Add any data above this commment
  // Any data added should follow the same syntax
];
export { nonOpaqueMaterials };
